import * as idEndpoints from './id';
import { root, id } from './users';

export const users = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
